import React, {createContext, useReducer} from 'react';
import {RESOLUTION_STATE_VALUES} from "../constants/local-storage";
import {CHANGE_PAGE_ID} from "../constants/action-types";
import {CHANGE_LOGGED_IN} from "../constants/action-types";
import {CHANGE_SELECTED_PROJECT} from "../constants/action-types";
import {CHANGE_SELECTED_BUILDING} from "../constants/action-types";
import {CHANGE_SELECTED_FLOOR} from "../constants/action-types";
import {CHANGE_OBSERVATION_HOUR} from "../constants/action-types";

const initialState = JSON.parse(localStorage.getItem(RESOLUTION_STATE_VALUES));
const store = createContext(initialState);
const {Provider} = store;

const StateProvider = ({children}) => {
	const [state, dispatch] = useReducer((state, action) => {
		var addState = {};
		switch(action.type){
			case CHANGE_PAGE_ID:
				addState = {...state, selectedPageId:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_LOGGED_IN:
				addState = {...state, loggedIn:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_SELECTED_PROJECT:
				addState = {...state, selectedProject:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_SELECTED_BUILDING:
				addState = {...state, selectedBuilding:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_SELECTED_FLOOR:
				addState = {...state, selectedFloor:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;
				
			case CHANGE_OBSERVATION_HOUR:
				addState = {...state, observationHour:action.value}
			  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify(addState));
				return addState;	
			
			default:
			 return '';
		}
	}, initialState);
	
	return <Provider value={{state, dispatch}}>{children}</Provider>;
};

export {store, StateProvider}
